import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import css from './OwnerAboutEmptyStoreHoursCard.module.css';

const OwnerAboutEmptyStoreHoursCard = ({ className }) => (
  <div className={classNames(css.card, className)}>
    <div className={css.titleWrapper}>
      <h3 className={css.title}>
        <FormattedMessage
          id="StorefrontTabContent.storeHours.title"
          defaultMessage="Store Hours"
        />
      </h3>
      <span className={css.description}>
        <FormattedMessage
          id="StorefrontTabContent.storeHours.onlineBooking"
          defaultMessage="Online booking available 24/7"
        />
      </span>
    </div>


    <div className={css.contentWrapper}>
      <div className={css.iconWrapper}>
        <i className="ri-time-line" aria-hidden />
      </div>
      <p className={css.contentDescription}>
        <>
          <FormattedMessage
            id="StoreProfilePage.about.emptyHours.description"
            defaultMessage="Set your store hours so customers know when you're available."
          />
        </>
      </p>
      <NamedLink name="StoreHoursPage" className={css.ctaLink}>
        <FormattedMessage
          id="StoreProfilePage.about.emptyHours.cta"
          defaultMessage="Set Store Hours"
        />
        <i className={classNames('ri-arrow-right-up-line', css.ctaArrow)} aria-hidden />
      </NamedLink>
    </div>
  </div>
);

OwnerAboutEmptyStoreHoursCard.propTypes = {
  className: PropTypes.string,
};

export default OwnerAboutEmptyStoreHoursCard;
